<template>
  <div class="back-bar" @click="handleBack">
    <div class="clickable-content d-flex">
      <v-icon color="black">mdi-chevron-left</v-icon>
      <div class="d-flex">
        <span class="font-weight-bold" v-if="title">
          {{ title | startCase }}
        </span>
        <slot name="additional-title" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parent: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },
  methods: {
    handleBack() {
      this.$router.push(this.parent);
    }
  }
};
</script>

<style lang="scss">
.back-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid $secondary-line;

  .clickable-content {
    cursor: pointer;
  }
}
</style>
